export enum AnalyticsPages {
  DASHBOARD = 'dashboard',
}

export enum AnalyticsPlaces {
  LIST = 'DashboardList',
  BLACK_LIST_USER_MODAL = 'BlackListUserModal',
}
